module.exports = __webpack_public_path__ + "images/87e797deed75a86136491a0b82023d49.svg";